import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import Status from './Common/Status'
import SageInfo from './Common/SageInfo'
import FreshDesk from './Common/FreshDesk'
import UserInformation from './Common/UserInformation'
import Customer from './Common/Customer'
import BillingAddress from './Common/BillingAddress'
import ShippingAddress from './Common/ShippingAddress'
import Discounts from './Common/Discounts'
import Transactions from './Common/Transactions'
import OrderNotes from './Common/OrderNotes'
import Processing from './Common/Processing'
import Items from './Common/Items/Items'
import Fulfillment from './Common/Fulfillment'
import OrderEvents from './Common/OrderEvents'
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { disableOrder, shippedOrder, setEvent, updateOrderPayload, pageNavigation, fetchSalesChannels } from '../../actions/index';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';
import { cyan900 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import _ from 'lodash'

const staging = (window.location.href.indexOf('staging.') > -1);
const isFulfillmentAdmin = ['0', '1', '2', '3', '4'].indexOf(localStorage.getItem('scope')) === 3;

const propTypes = {
  order: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onFulfillment: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  onEvent: PropTypes.func,
  orders: PropTypes.any,
  events: PropTypes.any,
  items: PropTypes.array,
  draw: PropTypes.any,
  auth: PropTypes.object.isRequired,
  productsList: PropTypes.object
};

class EditOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        name: null,
        description: null,
      },
      events: [],
      event: null,
      draw: false,
      order: {
        id: '',
        alert: '',
        sourceId: '',
        salesChannelId: 1,
        cartId: '',
        dropship: true,
        createDate: '',
        status: '',
        userId: '',
        confirmId: '',
        fulfillmentToken: '',
        giftcard: '',
        promocode: '',
        discount: {
          promoCode: '',
          discountName: '',
          discountType: '',
        },
        notes: {
          gift: '',
          order: [],
        },
        processing: {
          status: null,
          error: null,
          fulfillment: {
            status: null,
          },
          image: {
            status: null,
            images: [],
          },
          pdf: {
            status: null,
            pdfs: [],
          },
        },

      },
      open: false,
      edited: false,
      viewRedirect: false,
      openSnackbar: false,
      snackbarMessage: 'Processing...',
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    this.props.dispatch(fetchSalesChannels({ limit: 1000 }));
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ draw: false });
    if (nextProps.order) {
      var order = nextProps.order;
      if (!order.salesChannelId) order.salesChannelId = 1;
      if (!order.fulfillmentToken) order.fulfillmentToken = '';
      if (!order.shipping || (order.shipping.length > 0 && !order.shipping[0])) order.shipping = [order.shipping];
      // if (!order.transactions[0] || !order.transactions.length) order.transactions = [order.transactions];
      if (order.transactions === null) order.transactions = []
      if (!order.processing) order.processing = {};
      if (!order.processing.status) order.processing.status = '';
      if (!order.processing.error) order.processing.error = '';
      if (!order.processing.fulfillment) order.processing.fulfillment = {};
      if (!order.processing.fulfillment.status) order.processing.fulfillment.status = '';
      if (!order.processing.image) order.processing.image = {};
      if (!order.processing.image.status) order.processing.image.status = '';
      if (!order.processing.pdf) order.processing.pdf = {};
      if (!order.processing.pdf.status) order.processing.pdf.status = '';
      if (!order.notes) order.notes = [];
      if (!order.notes.order) {
        order.notes = {
          gift: '',
          order: [],
        };
      }
      delete order.createdAt;
      delete order.updatedAt;
      const draw = nextProps.draw;
      const events = nextProps.events;
      this.setState({
        order,
        draw,
        events,
      });
    }
  }

  handleNoteChange(e) {
    const nextState = this.state;
    _.set(nextState, e.target.name, e.target.value);
    this.setState({ nextState });
  }
  handleSaveNote() {
    const noteEntry = {
      admin: this.props.auth.user,
      date: Date.now(),
      text: this.state.noteText,
    };
    var new_notes = JSON.parse(JSON.stringify(this.props.order.notes))
    var new_orderNotes = new_notes.order
    new_orderNotes.push(noteEntry)
    new_notes.order = new_orderNotes
    this.props.dispatch(updateOrderPayload(this.props.order.id, 'notes', new_notes))
  }
  navigateToView() {
    if (this.state.edited === true) {
      const nextState = this.state;
      nextState.viewRedirect = true;
      nextState.item.assignedOnly = false;
      this.setState(nextState);
      this.handleOpen();
    } else {
      this.props.dispatch(pageNavigation('view')); // eslint-disable-line max-len
    }
  }
  navigateToEdit() {
    this.props.dispatch(pageNavigation('edit'))
  }
  handleCancelOrder() {
    const cancelOrderConfirm = confirm((this.props.order.status === 'processing')
      ? 'Are you sure, this cannot be undone! Order is already in fulfillment system!'
      : 'Are you sure, this cannot be undone!');
    if (cancelOrderConfirm) {
      this.props.dispatch(disableOrder(this.props.order.id));
      this.setState({ openSnackbar: true, snackbarMessage: 'Order marked as CANCELED.' });
      //this.props.dispatch(updateOrderPayload(this.props.order.id, 'alert', ''));
      const eventData = {
        type: 'order.canceled',
        source: this.props.auth.user,
        orderId: this.props.order.id,
        date: Date.now(),
        name: 'Set order to Canceled',
        details: JSON.stringify({}),
      };
      const newEvent = {
        type: eventData.type,
        subType: eventData.type.split(/\.(.+)/)[1],
        eventId: eventData.orderId,
        event: JSON.stringify(eventData),
      };
      this.props.dispatch(setEvent(newEvent));
    }
  }
  handleSetShipped() {
    this.props.dispatch(shippedOrder(this.props.order.id));
    this.setState({ openSnackbar: true, snackbarMessage: 'Order marked as SHIPPED.' });
    // this.props.dispatch(updateOrderPayload(this.props.order.id, 'alert', ''));
    const eventData = {
      type: 'order.shipped',
      source: this.props.auth.user,
      orderId: this.props.order.id,
      name: 'Set order to shipped',
      date: Date.now(),
      details: JSON.stringify({}),
    };
    const newEvent = {
      type: eventData.type,
      subType: eventData.type.split(/\.(.+)/)[1],
      eventId: eventData.orderId,
      event: JSON.stringify(eventData),
    };
    this.props.dispatch(setEvent(newEvent));
  }
  handleCancel() {
    this.setState({
      draw: false,
    });
    browserHistory.push('/orders?page=1');
  }
  handleNewPdf(itemId) {
    return itemId;
  }
  // handleClose() {
  //   const nextState = this.state;
  //   nextState.event = null;
  //   nextState.viewRedirect = nextState.edited = nextState.open = false;
  //   delete nextState.cancelLineItem;
  //   this.setState({ nextState });
  //   if (this.state.viewRedirect) {
  //     browserHistory.push(`/orders/view/${this.props.order.id}?orderId=${this.props.order.id}`); // eslint-disable-line max-len
  //   }
  // }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      this.props.dispatch(pageNavigation('view'))
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Order Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this order?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.props.item.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(this.state.item);
        break;
      default:
        this.props.onSave(this.state.item);
        break;
    }
  }
  sendToFulfillment(sendTo) {
    const { order } = this.state;
    this.props.onFulfillment(order, sendTo)
  }

  renderButtons() {
    const { status } = this.state.order
    const { order } = this.props
    let cancelOrderButton = '';
    let fulfillmentButton = '';
    let shippedButton = '';
    const hideFulfillment = (['0', '1', '2', '3', '4'].indexOf(localStorage.getItem('scope')) === 3) ? 'hidden' : 'visible';
    const hideReadOnly = (['0', '1', '2', '3', '4'].indexOf(localStorage.getItem('scope')) === 4) ? 'hidden' : 'visible';
    const disableSageBtn = true // order && order.sageId ? true : false

    const viewButton = (<RaisedButton
      style={{ marginBottom: '20px', marginRight: '100px' }}
      label="View"
      primary
      onClick={this.navigateToView}
    />);
    const cancelButton = (<RaisedButton
      label="Cancel"
      style={{ marginBottom: '20px', marginRight: '10px' }}
      primary
      onClick={this.handleCancel}
    />)
    const reprintButton = (
      <a href={`https://reprints.myphoto.com/?uid=${this.state.order.userId}&isAdmin=YES`} target="_blank">
        <RaisedButton
          label="Reprint"
          style={{ marginBottom: '20px', marginRight: '10px' }}
          primary
        />
      </a>
    )
    if (_.includes(['pending', 'processing'], status)) {
      cancelOrderButton = (<RaisedButton
        style={{ marginBottom: '20px', marginRight: '10px', visibility: hideFulfillment }}
        label="Cancel Order"
        primary
        onClick={this.handleCancelOrder}
      />);
    }
    if (_.includes(['pending'], status)) {
      fulfillmentButton = (
        <span>
          <RaisedButton
            style={{ marginBottom: '20px', marginRight: '10px', visibility: hideFulfillment }}
            label="Send to SAGE"
            primary
            disabled={disableSageBtn}
            onClick={(e) => {
              e.preventDefault;
              this.sendToFulfillment('sage')
            }}
          />
          <RaisedButton
            style={{ marginBottom: '20px', marginRight: '10px', visibility: hideFulfillment }}
            label="Send to NetSuite"
            primary
            onClick={(e) => {
              e.preventDefault;
              this.sendToFulfillment('NetSuite');
            }}
          />
        </span>
      );
    }
    if (_.includes(['processing'], status)) {
      shippedButton = (<RaisedButton
        style={{ marginBottom: '20px', marginRight: '10px', visibility: hideFulfillment }}
        label="Mark as Shipped"
        primary
        onClick={this.handleSetShipped}
      />);
    }
    return (
      !this.props.navigationType
        ? <div style={{ paddingLeft: '40px', paddingBottom: '10px' }}>
          {cancelButton}
          {viewButton}
          {cancelOrderButton}
          {fulfillmentButton}
          {shippedButton}
          {reprintButton}
        </div>
        : <div style={{ paddingLeft: '40px', paddingBottom: '10px' }}>
          {cancelButton}
          <RaisedButton
            style={{ marginBottom: '20px', marginRight: '10px', visibility: hideReadOnly }}
            label="Edit"
            primary
            onClick={this.navigateToEdit}
          />
        </div>)
  }
  render() {
    const { dispatch, order } = this.props
    const sageId = order && order.sageId ? order.sageId : null
    const ticket = order && order.ticket ? order.ticket : null
    const nsOrderId = order && order.nsOrderId ? order.nsOrderId : null
    const nsOrderNumber = order && order.nsOrderNumber ? order.nsOrderNumber : null
    const ticketId = order && order.ticketId ? order.ticketId : ''
    const isCanceled = this.state.order.status === 'canceled'
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '15px',
        width: '250px',
      },
      inputStyleShort: {
        marginRight: '15px',
        width: '150px',
      },
      inputStyleLong: {
        marginRight: '15px',
        width: '310px',
      },
    };
    var salesChannelFind = {};
    if (this.props.salesChannels && this.props.salesChannels.results && this.props.salesChannels.results[0].id) {
      salesChannelFind = _.find(this.props.salesChannels.results, ['id', this.props.order.salesChannelId])
    }
    const totalItems = (order.items) ? order.items.reduce((a, i) => {
      return a + i.qty * i.num_photos
    }, 0) : null
    const totalLines = (order.items) ? order.items.length : null
    return (
      <div style={{ width: '100%' }}><h2>
        {!this.props.navigationType ? 'Edit Order' : 'View Order'}
        &nbsp;&mdash; {totalItems} Items / {totalLines} Lines</h2>
        <div>
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          {this.renderButtons()}
          <Status
            styles={styles}
            order={this.state.order}
            dispatch={dispatch}
          />
          <br />
          {(sageId || nsOrderId) && <SageInfo sageId={sageId} nsOrderId={nsOrderId} nsOrderNumber={nsOrderNumber} />}
          <UserInformation
            styles={styles}
            order={order}
            saleschannelName={salesChannelFind !== undefined && salesChannelFind.hasOwnProperty('displayName') ? salesChannelFind.displayName : ''}
          />
        </div>
        <Customer
          styles={styles}
          order={order}
          dispatch={dispatch}
          isFulfillmentAdmin={isFulfillmentAdmin}
          isCanceled={isCanceled}
          disableView={this.props.navigationType}
        />
        {ticketId && <FreshDesk ticket={ticket} ticketId={ticketId} />}
        <BillingAddress
          styles={styles}
          order={order}
          dispatch={dispatch}
          disableView={this.props.navigationType}
        />
        <ShippingAddress
          styles={styles}
          order={order}
          dispatch={dispatch}
          disableView={this.props.navigationType}
        />
        <Transactions styles={styles} order={order} />
        <Discounts styles={styles} order={order} />
        <OrderNotes
          order={this.state.order}
          noteText={this.state.noteText}
          auth={this.props.auth}
          handleSaveNote={this.handleSaveNote}
          handleNoteChange={this.handleNoteChange}
        />
        <Items order={order} staging={staging} />
        <Fulfillment order={this.props.order} />
        <Processing styles={styles} order={this.props.order} />
        <OrderEvents events={this.props.events} />
        <Snackbar
          open={this.state.openSnackbar}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
        />
      </div>
    )
  }
}

EditOrder.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditOrder.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    draw: state.orders.draw,
    orders: state.orders.results,
    // events: state.events.results !== [] ? state.events.results : state.events.event,
    events: state.events.results,
    salesChannels: state.salesChannels,
    navigationType: state.admins.navigationType,
  };
}

export default connect(mapStateToProps)(EditOrder);


// WEBPACK FOOTER //
// ./src/components/orders/EditOrder.js